import { trpc } from '../lib/trpc';

export function useComments(threadId: number | null, limit = 20) {
  return trpc.comments.getForThread.useInfiniteQuery(
    { threadId: threadId ?? 0, limit },
    {
      getNextPageParam: (lastPage) => lastPage.nextCursor,
      enabled: !!threadId,
    }
  );
}

export function usePinnedComments(threadId: number | null) {
  return trpc.comments.getPinned.useQuery({ threadId: threadId ?? 0 }, { enabled: !!threadId });
}

export function useGetReplies(parentId: number | null) {
  return trpc.comments.getReplies.useQuery({ parentId: parentId ?? 0 }, { enabled: !!parentId });
}

export function useCreateComment() {
  const utils = trpc.useUtils();

  return trpc.comments.create.useMutation({
    onSuccess: (_, variables) => {
      utils.comments.getForThread.invalidate({ threadId: variables.threadId });
      utils.comments.getPinned.invalidate({ threadId: variables.threadId });
      if (variables.parentId)
        utils.comments.getReplies.invalidate({ parentId: variables.parentId });
    },
  });
}

export function useUpdateComment() {
  const utils = trpc.useUtils();

  return trpc.comments.update.useMutation({
    onSuccess: (res) => {
      if (res.comment) {
        utils.comments.getForThread.invalidate({ threadId: res.comment.threadId });
        utils.comments.getPinned.invalidate({ threadId: res.comment.threadId });
        if (res.comment.parentId)
          utils.comments.getReplies.invalidate({ parentId: res.comment.parentId });
      }
    },
  });
}

export function useDeleteComment() {
  const utils = trpc.useUtils();

  return trpc.comments.delete.useMutation({
    onSuccess: () => {
      utils.comments.invalidate();
    },
  });
}

export function useTogglePinComment() {
  const utils = trpc.useUtils();

  return trpc.comments.togglePin.useMutation({
    onSuccess: (res) => {
      if (res.comment) {
        utils.comments.getForThread.invalidate({ threadId: res.comment.threadId });
        utils.comments.getPinned.invalidate({ threadId: res.comment.threadId });
      }
    },
  });
}

export function useToggleReaction() {
  const utils = trpc.useUtils();

  return trpc.comments.toggleReaction.useMutation({
    onSuccess: (res) => {
      if (res.comment) {
        utils.comments.getForThread.invalidate({ threadId: res.comment.threadId });
        utils.comments.getPinned.invalidate({ threadId: res.comment.threadId });
      }
    },
  });
}
